import React from "react";

export default function OptionallyDisplayed({ children, doDisplay = false }) {
  return doDisplay ? <>{children}</> : null;
}
